export const Fees = {
    ORDER_DELIVERY_TYPE_FEE : 1,
    ORDER_CANCELATION_TYPE_FEE : 2,
    ORDER_REFUND_TYPE_FEE : 3,
    ORDER_DELIVERY_REVERT_TYPE_FEE : 4,
    ORGANISATION_WIRE_TRANSFER_FEE : 5,
}